/***
 * @file:è®¾ç½®æ½å±
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, NgZone, Renderer2 } from '@angular/core';
import { isEqual } from 'lodash';

import { NzMessageService } from 'ng-zorro-antd';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { Color, ContentWidth, NavMode, Style, ThemeConfig } from '@ithinkdt/theme/models';

import { LazyService } from './lazy.service';
import {
  COLOR_KEY,
  COLORS,
  CONTENT_WIDTH_KEY,
  CONTENT_WIDTHS,
  DEFAULT_CONTENT_WIDTH,
  DEFAULT_FIX_HEADER,
  DEFAULT_HIDE_HEADER,
  DEFAULT_NAV_MODE,
  FIX_HEADER_KEY,
  HIDE_HEADER_KEY,
  NAV_MODE_KEY,
  NAV_MODES,
  STYLE_KEY,
  STYLES,
} from './setting-drawer.config';

// åºå®æçæ¶èç°å¨åheaderä¸èµ·ï¼åé¢å¦æéè¦åå¼ç®¡çåå¼å¥ FIX_COLLECTION_KEY, HIDE_COLLECTION_KEY, DEFAULT_FIX_COLLECTION, DEFAULT_HIDE_COLLECTION
@Component({
  selector: 'dt-setting-drawer',
  templateUrl: './setting-drawer.component.html',
  styleUrls: ['./setting-drawer.component.scss'],
})
export class SettingDrawerComponent implements AfterViewInit {
  constructor(
    private cd: ChangeDetectorRef,
    private msg: NzMessageService,
    private lazy: LazyService,
    private renderer: Renderer2,
    private zone: NgZone,
    private i18n: I18NService,
    @Inject(DOCUMENT) private doc: any,
    private settingsSrv: SettingsService
  ) {
    this.themeConfig = this.settingsSrv.userConfig['theme'] || {};
    this.getThemeConfig();
    this.getStored();
  }

  get colorsClass() {
    const colorsClass: string[] = this.colors.map((color) => {
      return color.className;
    });
    return colorsClass;
  }

  get stylesClass() {
    const stylesClass: string[] = this.styles.map((style) => {
      return style.className;
    });
    return stylesClass;
  }
  themeConfig: ThemeConfig;
  collapse = false;
  // ä¸»é¢é£æ ¼
  styles: Style[];
  style: Style;
  defaultStyle: Style;
  // ä¸»é¢é¢è²
  colors: Color[];
  color: Color;
  deafultColor: Color;
  // å¯¼èªæ¨¡å¼: ä¾§è¾¹èåãé¡¶é¨èå
  navModes: NavMode[] = NAV_MODES;
  topMenu: NavMode; // æ¯å¦ä¸ºé¡¶é¨èå
  // åå®¹å®½åº¦è®¾å®: å®å®½ | æµå¼
  contentWidths: ContentWidth[] = CONTENT_WIDTHS;
  fixWidth: boolean; // åå®¹æ¯å¦ä¸ºå®å®½
  // åºå®å¤´é¨
  fixHeader: boolean;
  // éèå¤´é¨
  hideHeader: boolean;
  // // åºå®æçæ¶è
  // isfixCollection: boolean;
  // // éèæçæ¶è
  // isHideCollection: boolean;
  // æ¯å¦å è½½lessæä»¶
  private loadedLess = false;

  // è®¾ç½®æ½å±æ¾ç¤º/éè: é¿åæå¨äºä»¶åç¹å»äºä»¶åæ¶è§¦å
  dowmPosi = [];
  upPosi = [];

  ngAfterViewInit() {
    this.resetData();
  }

  // è·å¾å¼åèéç½®çæ°æ®ï¼è¥æ åä½¿ç¨é»è®¤ç
  private getThemeConfig() {
    this.styles = this.themeConfig['styles'] || STYLES;
    // this.setDefaultStyle(this.styles);
    this.defaultStyle = this.styles[0];
    this.colors = this.themeConfig['colors'] || COLORS;
    // this.setDefaultColor(this.colors);
    this.deafultColor = this.colors[0];
  }

  // åå§åè®¾ç½®é»è®¤ä¸»é¢å¸å±æ ·å¼
  // setDefaultStyle(styles) {
  //   const style = this.settingsSrv.layout['style']
  //     ? this.settingsSrv.layout['style']['key']
  //     : this.themeConfig['defaultStyle'] || '';
  //   if (style) {
  //     styles.forEach((item) => {
  //       if (style === item.key) {
  //         this.defaultStyle = item;
  //         this.changeStyle(item);
  //       }
  //     });
  //     return;
  //   }
  //   this.defaultStyle = styles[0];
  // }

  // åå§åè®¾ç½®é»è®¤ä¸»é¢é¢è²
  // setDefaultColor(colors) {
  //   const color = this.settingsSrv.layout['color']
  //     ? this.settingsSrv.layout['color']['key']
  //     : this.themeConfig['defaultColor'] || '';
  //   if (color) {
  //     colors.forEach((item) => {
  //       if (color === item.key) {
  //         this.deafultColor = item;
  //         this.runLess(item.className, 'detault');
  //       }
  //     });
  //     return;
  //   }
  //   this.deafultColor = colors[0];
  // }

  // è·åç¨æ·ä¹åçè®¾ç½®
  private getStored() {
    this.style = this.cachedData(STYLE_KEY) || this.defaultStyle;
    this.color = this.cachedData(COLOR_KEY) || this.deafultColor;
    this.topMenu = this.cachedData(NAV_MODE_KEY) || DEFAULT_NAV_MODE;
    this.fixWidth = this.cachedData(CONTENT_WIDTH_KEY) || DEFAULT_CONTENT_WIDTH;
    this.fixHeader = this.cachedData(FIX_HEADER_KEY) || DEFAULT_FIX_HEADER;
    this.hideHeader = this.cachedData(HIDE_HEADER_KEY) || DEFAULT_HIDE_HEADER;
    // this.isfixCollection = this.cachedData(FIX_COLLECTION_KEY) || DEFAULT_FIX_COLLECTION;
    // this.isHideCollection = this.cachedData(HIDE_COLLECTION_KEY) || DEFAULT_HIDE_COLLECTION;
  }

  // éå¨domåç´ æ¸²æä¹åæ¹å¯è°ç¨
  private resetData() {
    // console.log("this.color", this.color, "this.deafultColor", this.deafultColor)
    // å¤åæ´ä½é£æ ¼
    if (!isEqual(this.style, this.defaultStyle)) {
      this.changeCustomDefinition(this.stylesClass, this.style.className);
    }
    // å¤åä¸»é¢é¢è²
    if (!this.themeConfig['hideColorChange'] && !isEqual(this.color, this.deafultColor)) {
      this.runLess(this.color.className);
    } else {
      // ng-zorroçé»è®¤æ ·å¼å¨theme.lessæä»¶ä¸­ä¼èªå¨è¯»åï¼èåç­é¨åä¸ºèªå®ä¹cssï¼éæå¨è§¦åé»è®¤æ ·å¼
      this.changeCustomDefinition(this.colorsClass, this.color.className);
    }
  }

  toggle() {
    this.collapse = !this.collapse;
  }

  // æ¹åé£æ ¼æ ·å¼
  changeStyle(style: Style) {
    if (isEqual(this.style, style)) {
      return;
    }

    this.style = style;
    this.changeCustomDefinition(this.stylesClass, style.className);
    this.storeData(STYLE_KEY, style);
  }

  // æ¹åä¸»é¢è²
  changeColor(color: Color) {
    if (isEqual(this.color, color)) {
      return;
    }

    this.color = color;
    this.runLess(color.className);
  }

  // æ¹åå¯¼èªæ¨¡å¼
  changeMode(navMode: NavMode) {
    if (isEqual(this.topMenu, navMode)) {
      return;
    }

    // å¦ææ¯ä¾§è¾¹èå,åä¸åè®¸è®¾ç½®å¤´é¨,å æ¹åå¼å³å¼ä¸ä¼è§¦åå­å¨ï¼ææå¨è§¦å
    if (navMode === false) {
      this.setNavToDefault();
    }

    this.topMenu = navMode;
    this.storeData(NAV_MODE_KEY, navMode);
  }

  // åå®¹å®½åº¦è°æ´
  contentWidthChange(val: boolean) {
    this.fixWidth = val;
    this.storeData(CONTENT_WIDTH_KEY, val);
  }

  // åºå®å¤´é¨
  fixHeaderChange(val: boolean) {
    if (!val) {
      // å¦æä¸æ¯åºå®å¤´é¨ï¼åä¸è½ä¸æ»éèå¤´é¨
      this.hideHeaderChange(val);
    }
    this.fixHeader = val;
    this.storeData(FIX_HEADER_KEY, val);
  }

  // ä¸æ»éèå¤´é¨
  hideHeaderChange(val: boolean) {
    this.hideHeader = val;
    this.storeData(HIDE_HEADER_KEY, val);
  }

  // // åºå®æ¶è
  // fixCollectionChange(val:boolean){
  //  this.isfixCollection = val;
  //   this.storeData(FIX_COLLECTION_KEY, val);
  // }

  // // ä¸æ»éèæçæ¶è
  // hideCollectionChange(val:boolean){
  //   this.isHideCollection = val;
  //   this.storeData(HIDE_COLLECTION_KEY, val);
  // }

  // ä½¿ç¨é»è®¤å¼å¤´é¨æ ·å¼
  private setNavToDefault() {
    this.contentWidthChange(DEFAULT_CONTENT_WIDTH);
    this.fixHeaderChange(DEFAULT_FIX_HEADER);
    // this.fixCollectionChange(DEFAULT_HIDE_HEADER);
    // this.hideCollectionChange(DEFAULT_HIDE_COLLECTION);
  }

  private runLess(className) {
    const { zone, msg, cd } = this;
    const msgId = msg.loading(this.i18n.interpret('settingDrawer.themeCompiled'), { nzDuration: 0 }).messageId;
    setTimeout(() => {
      zone.runOutsideAngular(() => {
        this.loadLess().then(() => {
          try {
            // this.store.set("lessfunc", (window as any).less.modifyVars);
            (window as any).less.modifyVars(this.genVars()).then(() => {
              this.changeCustomDefinition(this.colorsClass, className);
              // if (!type) {
              msg.success(this.i18n.interpret('settingDrawer.successfulCompilation'));
              // }
              msg.remove(msgId);
              this.loadedLess = true;
              zone.run(() => cd.detectChanges());
            });
          } catch (e) {
            msg.remove(msgId);
            // window.location.reload();
          }
        });
      });
    }, 200);
  }

  private loadLess(): Promise<void> {
    if (this.loadedLess || (window as any).ithinkDTScriptExist) {
      return Promise.resolve();
    }

    return this.lazy
      .loadStyle('./assets/css/theme.less', 'stylesheet/less')
      .then(() => {
        const lessConfigNode = this.doc.createElement('script');
        lessConfigNode.innerHTML = `
          window.less = {
            async: true,
            env: 'production',
            javascriptEnabled: true
          };
        `;
        this.doc.body.appendChild(lessConfigNode);
        (window as any).ithinkDTScriptExist = true;
      })
      .then(() => this.lazy.loadScript('https://gw.alipayobjects.com/os/lib/less.js/3.8.1/less.min.js'))
      .then(() => {
        this.loadedLess = true;
      });
  }

  private genVars() {
    const vars: any = {
      [`@primary-color`]: this.color.color,
    };
    this.storeData(COLOR_KEY, this.color);
    return vars;
  }

  changeCustomDefinition(allClasses, className) {
    this.removeAllClass(allClasses);
    this.addClass(className);
  }

  addClass(className) {
    this.renderer.addClass(this.doc.body, className);
  }

  // ç§»é¤bodyä¸çææclass
  removeAllClass(allClasses) {
    allClasses.forEach((className) => {
      this.renderer.removeClass(this.doc.body, className);
    });
  }

  private cachedData(type) {
    return this.settingsSrv.layout[type];
  }

  private storeData(name: string, value: any) {
    this.settingsSrv.setLayout(name, value);
  }

  onMousedown(event: MouseEvent) {
    const { pageX, pageY } = event;
    this.dowmPosi.push(pageX, pageY);
  }

  onMouseup(event: MouseEvent) {
    const { pageX, pageY } = event;
    this.upPosi.push(pageX, pageY);
    if (isEqual(this.dowmPosi, this.upPosi)) {
      this.toggle();
    }
    this.resetMouseFlag();
  }

  resetMouseFlag() {
    this.dowmPosi = [];
    this.upPosi = [];
  }
}
